<template>
   <Ai-companion-dialog :visible.sync="visible"  @closed="handleCloseDialog" />
</template>

<script>
import { ConfirmComponent } from '../common/service-dialog/confirm';
import { showModalDialogCloseButton, hideModalDialogCloseButton } from '@/utils/modal-utils.js';
import { AI_COMPANION_DIALOG as AiCompanionDialog } from '@zoom/billing-shared';

export default {
name: 'CompanionBanner',
mixins: [ConfirmComponent],
components: {
    AiCompanionDialog
  },
data () {
  return {
    visible: false,
  };
},
watch: {
  visible(val) {
    if (this.$context.is.modal) {
      val ? hideModalDialogCloseButton() : showModalDialogCloseButton();
    }
  }
},
mounted () {
},
beforeDestroy () {
  this.removeVideoListener();
},
methods: {
  handleCloseDialog () {
    this.visible = false;
  },
},
};
</script>
